export enum ShoppingFilter {
    ACTUAL = "actual",
    HISTORY = "history",
}

export enum ShoppingSorting {
    TIME = "time",
    NEW = "new",
}
